import {Component, Input, OnDestroy} from '@angular/core';
import {BehaviourTrackerService} from "../../service/behaviour-tracker.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {screenSize} from "../../../../shared/core/shared.selectors";
import {Subject, takeUntil} from "rxjs";
import moment from 'moment';

interface WeeklyDateSelector {
  date: string;
  sessionNumber: number | null;
  isSession: boolean;
  isSelected: boolean;
}

@Component({
  selector: 'app-day-selector',
  templateUrl: './day-selector.component.html',
  styleUrls: ['./day-selector.component.css']
})
export class DaySelectorComponent implements OnDestroy {
  @Input() data: WeeklyDateSelector[];
  screenSizeClass: "xs" | "sm" | "md" | "lg" | "xl" | "";
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private participantService: BehaviourTrackerService,
    private store: Store<fromRoot.State>,
  ) {
    this.store.select(screenSize)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.screenSizeClass = data;
      });

  }

  ngOnChanges() {
    this.data.forEach(eachItem => {
      if (eachItem.isSelected) {
        this.participantService.selectedDayData.next(eachItem);
      }
    });
  }

  select(item) {
    if (this.isFuture(item)) {
      return;
    }
    this.data.forEach(eachItem => {
      if (eachItem.isSelected) {
        eachItem.isSelected = false;
      }
    });
    item.isSelected = true;
    this.participantService.selectedDayData.next(item);
  }

  isFuture(week) {
    return moment(week.date).isAfter(moment());
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
